import { joinKeys } from 'helpers/translations.helper'
import { prefixTranslation as base } from '../../common'

export const prefixTranslation = joinKeys(base, 'externalCourses')
